<template>
    <el-dialog :visible.sync="lableShow" width="738px" :show-close="false" @close="close" center
        :close-on-press-escape="false" :close-on-click-modal="false">
        <div class="lable_popup">
            <div class="lable_title">
                {{ title }}
                <i class="el-icon-close cursor_1" @click="lableShow = false"></i>
            </div>
            <div class="lable_popup8">
                <!-- <div class="cursor_1" :class="lableTitleI == i ? 'lable_popup8_1 lable_popup8_2' : 'lable_popup8_1'"
                    v-for="(item, i) in lableTitle" :key="i" @click="changeTitle(i,item)">
                    {{ item }}
                    <div v-if="lableTitleI == i" class="lable_popup8_3"></div>
                </div> -->
                <tabsLable v-model="lableTitleI" :tabs="lableTitle" @change="changeTitle" />
            </div>
            <div class="lable_popup1" ref="scrollContainer" @scroll="handleScroll">
                <div class="lable_popup1_1" v-for="(item, i) in lableList" :key="i">
                    <div class="lable_popup1_2" :ref="`lable${i}`">{{ item.paramName }}</div>
                    <div class="lable_popup1_3">
                        <div class="cursor_1 lable_popup200" :class="lable.select ? ' lable_popup3' : ''"
                            v-for="(lable, l) in item.placeholder" :key="l" @click="select(i, l)">
                            {{ lable.name }}
                            <img v-if="lable.icon" :src="lable.icon" class="hot" width="15" height="18"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lable_popup4">
                <el-input v-model="input" maxlength="200" show-word-limit placeholder="请输入自定义标签，多个标签之间请用逗号,隔开"></el-input>
            </div>
            <div class="lable_popup5">
                <div class="lable_popup6">{{ selectLen }}/{{ maxLableNum }}</div>
                <div class="lable_popup7 cursor_1" ref="confirmBtn" :loading="loading"
                    @click="confirm">确认
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import api from '@/api/api';
import _ from 'lodash'
import tabsLable from '@/components/dongeb/tabsLable.vue';
export default {
    components: {
        tabsLable
    },
    props:{
        title:{
            type:String,
            default:'作品标签'
        }
    },
    data() {
        return {
            lableShow: false, //标签选择弹框显示
            lableTitle: [], //标签头部
            lableTitleI: 0,//标签头部下标
            lableList: [], //所有标签
            lableI: [], //选中标签
            customizeL: [], //自定义标签
            lableTop: [],
            loading: false,
            input: '',
            isScrolling: true, //是否滚动
            selectLableType: '',//当前选中标签类型
        }
    },
    computed: {
        selectLen() {
            return this.sumSelectedLen();
        }
    },
    watch: {
        input(newVal) {
            if (newVal) {
                let len = this.lableI.length;
                if (len >= this.maxLableNum) {
                    this.input = ''
                    this.$message.warning(`无法自定义标签，已选${this.maxLableNum}个标签`)
                    return
                }
            }
        }
    },
    methods: {
        openLable(data) {
            console.log('标签=',data)
            this.getLable()
            setTimeout(() => {
                if (this.lableList.length) {
                    // 先清空之前的选择
                    this.lableI = [];
                    // 更新labelList并同步收集选中的项
                    this.lableList = this.lableList.filter(item => {
                       item.placeholder = item.placeholder.map(placeholderItem => {
                            const matched = data.find(val => val === (item.paramName+'-'+ placeholderItem.name));
                            if (matched) {
                                this.lableI.push(item.paramName + '-' + placeholderItem.name)// 推送匹配的原始数据
                                return { ...placeholderItem, select: true };
                            }
                            return { ...placeholderItem, select: false };
                        });
                        return item
                    });
                    data.forEach(item => {
                        if (!this.lableI.includes(item)) {
                            this.input = item.replace(/^自定义-/, '');
                        }
                    })
                    console.log('this.lableList=',this.lableList)
                    this.lableList.forEach((item, i) => {
                        this.lableTop.push(this.$refs[`lable${i}`][0].offsetTop)
                    })
                }
            }, 200)
            this.lableShow = true
        },
        // 切换title
        changeTitle(i, name) {
            console.log('i=', i)
            console.log('name=', name)
            this.isScrolling = false
            const scrollContainer = this.$refs.scrollContainer;
            const lable = this.$refs[`lable${i}`];
            if (lable) {
                this.selectLableType = name
                const lableOffsetTop = lable[0].offsetTop - 147;
                scrollContainer.scrollTop = lableOffsetTop;
            }
            this.lableTitleI = i
        },
        // 获取标签
        getLable() {
            api.getParameter('pcxscs', 'label').then((res) => {
                if (res.code == 200) {
                    res.data[0].children.map((item) => {
                        this.lableTitle.push(item.paramName)
                        item.placeholder = item.placeholder.split(',').map((label) => ({
                            select: false,
                            name: label.indexOf('*') !== -1 ? label.replace(/\*/g, '') : label,
                            icon: label.indexOf('*') !== -1 ? require('@/assets/image/hot.png'):''
                        }))
                    })
                    this.lableList = res.data[0].children
                }
            })
        },
        // 选择标签
        select(i, l) {
            let selectLen = this.sumSelectedLen();
            this.lableList[i].placeholder.map((item, index) => {
                if (l === index) {
                    if (selectLen === this.maxLableNum) {
                        if (item.select) {
                            item.select = false
                            return
                        }
                        this.$message.warning(`最多选${this.maxLableNum}个标签`);
                        return
                    }
                    item.select = !item.select
                }
            })
            let data = this.lableList.map(lable => lable.placeholder.filter(item => item.select).map(item => lable.paramName + '-' + item.name))
            this.lableI = [].concat(...data)
            // console.log(this.lableI)
        },
        // 计算选中总长度
        sumSelectedLen() {
            this.input = this.convertCommas(this.input)
            return this.lableI.length + (this.input ? 1 : 0);
        },
        // 确认
        confirm() {
            let len = this.sumSelectedLen();
            if (len > this.maxLableNum) {
                this.$message.warning(`最多选${this.maxLableNum}个标签`);
                return
            }
            this.loading = true
            let a = _.cloneDeep(this.lableI);
            if (this.input) {
                a = a.concat(`自定义-${this.input}`)
            }
            this.$emit('getLable', a)
            this.close()
        },
        // 关闭
        close() {
            this.lableShow = false
            this.lableTitle = []
            this.lableI = []
            this.customizeL = []
            this.input = ''
        },
        handleScroll() {
            const scrollContainer = this.$refs.scrollContainer;
            const currentScrollTop = scrollContainer.scrollTop;
            this.lableTop.map((item, i) => {
                if (currentScrollTop + 147 >= item) {
                    if (this.isScrolling) {
                        this.lableTitleI = i
                    }

                }
            });
        }

    }
}
</script>

<style>
#novel_create .el-dialog__header,
#novel_create .el-dialog__header {
    padding: 0;
}

#novel_create .el-dialog__body,
#novel_create .el-dialog__body {
    padding: 0;
    background-color: transparent !important;
}

#novel_create .el-dialog,
#novel_create .el-dialog {
    background-color: transparent !important;
    box-shadow: none;
}

.cursor_1:hover {
    opacity: 0.8;
}

.lable_popup {
    width: 738px;
    padding-bottom: 20px;
    border-radius: 12px;
    background-color: #FFFFFF;
    overflow: hidden;
}

.lable_title {
    width: 100%;
    height: 75px;
    font-size: 19px;
    color: #111111;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #F5F7FA;
    padding: 0 42px;
}

.lable_popup1 {
    width: 738px;
    max-height: 200px;
    padding: 0 40px;
    margin: 20px 0 5px 0;
    overflow: auto;
    -ms-overflow-style: none;
    /* IE和Edge浏览器下隐藏滚动条 */
    scrollbar-width: none;
    /* Firefox下隐藏滚动条 */
}

.lable_popup1_2 {
    margin-bottom: 13px;
}

.lable_popup1_3 {
    display: flex;
    flex-flow: wrap;
}

.lable_popup200 {
    position: relative;
    width: 92px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 5px;
    min-height: 38px;
    flex-wrap: wrap;
    border: 1px solid #EEEEEE;
    font-size: 15px;
    font-weight: 400;
    color: #666666;
    border-radius: 8px;
    margin-right: 21px;
    margin-bottom: 15px;
}
.hot{
    position: absolute;
    top: -10px;
    right: -6px;
}
.lable_popup200:nth-child(6n) {
    margin-right: 0;
}

.lable_popup3 {
    border: 1px solid var(--tech-primary);
    color: var(--tech-primary);
}

.lable_popup4 {
    width: 738px;
    padding: 0 40px;
}

.lable_popup5 {
    width: 738px;
    padding: 0 40px;
    display: flex;
    align-items: center;
    margin-top: 20px;
    justify-content: space-between;
}

.lable_popup6 {
    font-size: 13px;
    color: #333333;
    font-weight: 400;
}

.lable_popup7 {
    width: 100px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    background-color: var(--tech-primary);
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 400;
    border-radius: 8px;
}

.lable_popup8 {
    width: 738px;
    overflow-x: scroll;
    white-space: nowrap;
    -ms-overflow-style: none;
    /* IE和Edge浏览器下隐藏滚动条 */
    scrollbar-width: none;
    /* Firefox下隐藏滚动条 */
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 0px;
    border-bottom: 1px solid #EBEFF4;
}

.lable_popup8_1 {
    font-weight: 400;
    font-size: 17px;
    color: #666666;
    margin-right: 33px;
    position: relative;
}

.lable_popup8_2 {
    color: #111111;
    font-weight: bold;
}

.lable_popup8_3 {
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translate(-50%);
    width: 17px;
    height: 4px;
    background: #FF6603;
    border-radius: 0px 0px 0px 0px;
}
</style>